// useClusters — fetch de cluster-config van de backend.
//
// Config wordt dynamisch gerenderd — niet hardcoded. Zelfde JSON als
// shared/cluster-config/clusters.json. PWA cached de response.

import { useCallback, useEffect, useState } from 'react';
import { api, endpoints } from '../api/client.js';

export function useClusters() {
    const [config, setConfig] = useState(null);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);

    const load = useCallback(async () => {
        setLoading(true);
        setError(null);
        try {
            const data = await api.get(endpoints.clusters);
            setConfig(data);
        } catch (err) {
            setError(err);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => { load(); }, [load]);

    return { config, loading, error, reload: load };
}
